






































import { mapGetters, mapActions } from 'vuex'
import AdminNavbar from '@/components/AdminNavbar.vue'
import AssessmentEditor from '@/components/AssessmentEditor.vue'

export default {
  name: 'AdminAssessment',
  components: {
    AdminNavbar,
    AssessmentEditor
  },
  data () {
    return {
      assessment: null,
      changedAssessment: null,
      // selections: []
    }
  },
  computed: {
    ...mapGetters([
      'riskLevels',
      'riskQuestions',
    ]),
    // riskQuestionsOptions () {
    //   const options = []
    //   for (let q=0; q<this.riskQuestions.length; q++) {
    //     options.push({
    //       value: 
    //     })
    //   }
    //   return options
    // },
    feedback () {
      const feedback = []
      let a: number
      for (let q=0; q<this.riskQuestions.length; q++) {
        if (!(typeof this.selections[q] === 'undefined' || this.selections[q] === null)) {
          a = this.selections[q]
          feedback.push(this.riskQuestions[q].options[a].feedback)
        } else {
          feedback.push('')
        }
      }
      return feedback
    }
  },
  methods: {
    ...mapActions([
      'getAssessment'
    ]),
    trackChanges (changedAssessment: Assessment) {
      console.log('trackChanges', changedAssessment)
      this.changedAssessment = changedAssessment
    }
    // chooseAnswer (q: number, a: number) {
    //   console.log('RiskAssessmentPage.chooseAnswer', q, a)
    //   this.$set(this.selections, q, a)
    //   console.log(this.selections)
    // }
  },
  async mounted () {
    console.log('RiskAssessment.mounted')
    let response = await this.getAssessment(this.$route.params.assessmentId)
    if (response.success) {
      this.assessment = response.data
    } else {
      this.$bvToast.toast(response.message, {
        title: 'Error',
        toaster: 'b-toaster-bottom-right',
        variant: 'danger',
        autoHideDelay: 5000
      })
    }
  },
  watch: {
    riskQuestions () {
      this.selections.length = this.riskQuestions.length
      for (let q=0; q<this.riskQuestions.length; q++) {
        if (typeof this.selections[q] === 'undefined') {
          this.selections[q] = null
        }
      }
      console.log(this.selections)
    }
  }
}
